<template>
  <div>


    <div class="modal fade" id="payment_cash_modal" tabindex="-1" role="dialog"
         aria-labelledby="payment_cash_modal_title" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="payment_cash_modal_title">{{ event.event_name }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Pour payer votre réservation en espèce, vous devez prendre rendez-vous à l'accueil du CSAM.</p>
            <FullCalendar :key="calendar_key" :options="calendar_options" ref="full_calendar" />
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="payment_card_modal" tabindex="-1" role="dialog"
         aria-labelledby="payment_card_modal_title" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div id="dlnkcalendar-wrapper" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="payment_card_modal_title">{{ event.event_name }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form id="user_info_form" method="post" @submit.prevent="post_user_info()"
                class="needs-validation" novalidate>

            <input type="hidden" name="id_event" :value="event.id">
            <input type="hidden" name="event_type_id" :value="event.event_type_id">

            <div class="modal-body">

              <div class="form-group">
                <label for="firstname">Prénom :<span class="text-danger">*</span></label>
                <input type="text" id="firstname" class="form-control is_required" :value="customer.firstname"
                       name="firstname" required>
              </div>
              <div class="form-group">
                <label for="lastname">Nom :<span class="text-danger">*</span></label>
                <input type="text" id="lastname" class="form-control is_required" :value="customer.lastname"
                       name="lastname" required>
              </div>
              <div class="form-group">
                <label for="email">Email :<span class="text-danger">*</span></label>
                <input type="email" id="email" class="form-control is_required" :value="customer.email" name="email"
                       required>
              </div>

              <div class="form-group">
                <label for="address">Adresse <span class="text-danger">*</span></label>
                <input type="text" class="form-control is_required" name="address" id="address"
                       placeholder="ex. 16 rue Lafayette" required>
              </div>
              <div class="form-group">
                <label for="address2">Complément d'adresse</label>
                <input type="text" class="form-control" name="address2" placeholder="ex. Bât. A" id="address2">
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="zipcode">Code postal <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" name="zipcode" id="zipcode" placeholder="ex. 75000"
                           required>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="city">Ville <span class="text-danger">*</span></label>
                    <input type="text" class="form-control is_required" name="city" id="city" placeholder="ex. Paris"
                           required>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-times" aria-hidden="true"></i>&nbsp;Annuler
              </button>
              <button type="submit" name="dlnkcalendarSubmitAnonymousInfo" class="btn btn-primary">
                <i class="fa fa-euro-sign" aria-hidden="true"></i>&nbsp;Payer par carte
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <div v-if="!customer.id && notice">
      <div class="position-relative bg-primary overflow-hidden">
        <div class="container position-relative z-index-2 space-top-1 space-top-md-1 space-bottom-1 space-bottom-md-1">
          <div class="w-md-80 w-xl-60 text-center mx-md-auto">
            <h1 class="text-white mb-4">{{ event.event_name }}</h1>
          </div>
        </div>
        <figure class="position-absolute right-0 bottom-0 left-0 mb-n1">
          <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
            <path fill="#F9F9F9" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>
          </svg>
        </figure>
      </div>
      <div class="w-80 mx-lg-auto my-2 alert alert-info mb-4" >
        <h2>ATTENTION</h2>
        <p>
          Si vous êtes déjà adhérents, connectez-vous avec vos identifiants et votre mot de passe  pour pouvoir accéder à la réservation de vos sorties.
          <br>
          Si vous n'êtes pas encore adhérents, vous pouvez vous inscrire. Un rendez-vous vous sera proposé pour valider
          votre adhésion (5€) et vos réservations.
        </p>

        <a href="/connexion" class="btn btn-danger">Me connecter</a>
        <a href="/connexion" class="btn btn-danger">M'inscrire</a>
<!--        <button type="button" class="btn btn-danger" @click="close_notice()">Continuer</button>-->
      </div>
    </div>

    <div v-else-if="parseInt(event.max_reservation)" id="content" class="dlnkcalendar-multi-registration">

      <div class="position-relative bg-primary overflow-hidden">
        <div class="container position-relative z-index-2 space-top-1 space-top-md-1 space-bottom-1 space-bottom-md-1">
          <div class="w-md-80 w-xl-60 text-center mx-md-auto">
            <h1 class="text-white mb-4">{{ event.event_name }}</h1>
          </div>
        </div>
        <figure class="position-absolute right-0 bottom-0 left-0 mb-n1">
          <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
            <path fill="#F9F9F9" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>
          </svg>
        </figure>
      </div>

      <div v-if="event.rules" id="event_rule" class="w-80 mx-lg-auto my-2 alert alert-info mb-4">
        <h2>Règle de l'évènement</h2>
        <p v-html="event.rules"></p>
      </div>

      <div v-if="(parseInt(event.availability) < parseInt(event.max_reservation)) && parseInt(event.availability) < 10"
           class="w-80 mx-lg-auto my-2 alert alert-warning mb-4">

        <span v-if="parseInt(event.availability) > 0">
          Il ne reste plus que {{ event.availability }} place(s) disponible(s). <br>
        </span>
        <span v-else>
          <strong>Il n'y a plus de places disponible.</strong> <br>
        </span>


        <div v-if="reservation_open">
          Je souhaite me mettre sur liste d'attente.
          <button @click="open_waiting_list()" type="button" class="btn btn-primary">Ouvrir la liste d'attente</button>
        </div>
        <div v-else-if="parseInt(event.availability) > 0">
          Je souhaite réserver des places.
          <button @click="open_reservation()" type="button" class="btn btn-primary">Réserver des places</button>
        </div>
      </div>

      <div v-if="event.availability > 10 && !reservation_open" class="w-80 mx-lg-auto my-2 alert alert-warning mb-4">
        <p>
          Il reste {{ event.availability }} places disponibles, je souhaite réserver.
          <button @click="open_reservation()" type="button" class="btn btn-primary">Réserver</button>
        </p>
      </div>

      <!-- WAITING LIST -->
      <div v-if="waiting_list_open" class="row m-2">
        <div class="col-lg-9 order-lg-1">
          <div class="card shadow-soft p-4 mb-4 h-90">
            <div class="border-bottom pb-3 mb-3">
              <h2 class="h3 mb-0 text-primary d-block mb-2">
                Liste d'attente
              </h2>
              <p class="mb-0 text-primary">
                Il ne reste plus suffisamment de place disponible, vous pouvez vous mettre sur liste d'attente si des
                places se
                liberent.
              </p>
              <p v-if="!adult_present" class="alert alert-danger">
                <i class="fas fa-exclamation-triangle"></i>&nbsp; Attention, au moins un adulte doit être présent.
              </p>
              <p v-if="!phone_present" class="alert alert-danger">
                <i class="fas fa-exclamation-triangle"></i>&nbsp; Attention, vous devez renseigner au moins un numéro de
                téléphone.
              </p>

            </div>

            <div class="border-bottom pb-2 mb-2">

              <form class="form-inline">
                <div class="form-group mb-2 mr-1">
                  <input ref="waiting_firstname_input" type="text" class="form-control form-control-xs" placeholder="Prénom" v-model="firstname">
                </div>
                <div class="form-group mb-2 mr-1">
                  <input type="text" class="form-control form-control-xs" placeholder="Nom" v-model="lastname">
                </div>
                <div class="form-group mb-2 mr-2">
                  <input type="text" class="form-control form-control-xs" placeholder="Téléphone" v-model="phone">
                </div>
                <div class="form-group mb-2 mr-2">
                  <input type="text" class="form-control form-control-xs" placeholder="Age" v-model="age">
                </div>

                <button type="submit" class="btn btn-primary mb-2" @click.prevent="add_waiting()">
                  <i class="fas fa-plus transition-3d-hover"></i>
                </button>
              </form>

              <div>

                <table class="table">
                  <thead>
                  <tr>
                    <th>Nom</th>
                    <th>Prénom</th>
                    <th>Téléphone</th>
                    <th>Age</th>
                    <th>Action</th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr v-for="waiting, index in waitings" :key="index">
                    <td>{{ waiting.lastname }}</td>
                    <td>{{ waiting.firstname }}</td>
                    <td>{{ waiting.phone }}</td>
                    <td>{{ waiting.age }}</td>
                    <td>
                      <a href="javascript:void(0);" class="btn btn-xs btn-icon btn-outline-danger rounded-circle"
                         data-toggle="tooltip" data-placement="top" title="Supprimer le participant"
                         @click="delete_waiting(index)">
                        <i class="fas fa-trash"></i>
                      </a>

                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3 order-lg-2 mb-7 mb-lg-0">
          <div class="pl-lg-4">
            <div class="card shadow-soft p-4 mb-4">
              <div class="border-bottom pb-4 mb-4"><h2 class="h3 mb-0 text-primary">Récapitulatif</h2>
              </div>
              <div class="media align-items-center pb-4 mb-4"><span class="d-block font-size-1 mr-3">{{
                  waitings.length
                }} places réservés</span>
                <div class="media-body text-right"><span class="text-dark font-weight-bold">
                {{ get_total() }}  €
              </span></div>
              </div>
              <div class="w-100">
                <div class="w-100 text-center cart_navigation clearfix">
                  <button type="button" @click="post_waitings()"
                          title="Continuer mes achats" class="btn btn-primary mb-1">
                    <i class="fas fa-save transition-3d-hover"></i> &nbsp;Valider
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- RESERVATIONS -->
      <div v-if="reservation_open && parseInt(event.availability) > 0" class="row m-2">
        <div class="col-lg-9 order-lg-1">
          <div class="card shadow-soft p-4 mb-4 h-90">
            <div class="border-bottom pb-3 mb-3">
              <h2 class="h3 mb-0 text-primary mb-2">
                Saisie des participants
              </h2>
              <p v-if="event.max_reservation < 100">
                Vous êtes autorisé à réserver pour {{ event.max_reservation }} personnes.
                Vous reservez pour {{ participants.length }} personne(s). <br>
                Vous pouvez encore reserver {{ parseInt(event.max_reservation) - participants.length }} places.
              </p>
              <p v-if="!adult_present" class="alert alert-danger">
                <i class="fas fa-exclamation-triangle"></i>&nbsp; Attention, au moins un adulte doit être présent.
              </p>
              <p v-if="!phone_present" class="alert alert-danger">
                <i class="fas fa-exclamation-triangle"></i>&nbsp; Attention, vous devez renseigner au moins un numéro de
                téléphone.
              </p>
            </div>

            <div class="border-bottom pb-2 mb-2">


              <form v-if="(parseInt(event.max_reservation) - participants.length) > 0 && parseInt(event.availability) > participants.length"
                    class="form-inline">
                <div class="form-group mb-2 mr-1">
                  <input ref="firstname_input" type="text" class="form-control form-control-xs" placeholder="Prénom"
                         v-model="firstname">
                </div>
                <div class="form-group mb-2 mr-1">
                  <input type="text" class="form-control form-control-xs" placeholder="Nom" v-model="lastname">
                </div>
                <div class="form-group mb-2 mr-2">
                  <input type="text" class="form-control form-control-xs" placeholder="Téléphone" v-model="phone">
                </div>
                <div class="form-group mb-2 mr-2">
                  <input type="text" class="form-control form-control-xs" placeholder="Age" v-model="age">
                </div>

                <button type="submit" class="btn btn-primary mb-2" @click.prevent="add_participant()">
                  <i class="fas fa-plus transition-3d-hover"></i>
                </button>
              </form>

              <div id="event_reservations">

                <table class="table">
                  <thead>
                  <tr>
                    <th>Prénom</th>
                    <th>Nom</th>
                    <th>Téléphone</th>
                    <th>Age</th>
                    <th>Action</th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr v-for="participant, index in participants" :key="index">
                    <td>{{ participant.firstname }}</td>
                    <td>{{ participant.lastname }}</td>
                    <td>{{ participant.phone }}</td>
                    <td>{{ participant.age }}</td>
                    <td>
                      <a href="javascript:void(0);" class="btn btn-xs btn-icon btn-outline-danger rounded-circle"
                         data-toggle="tooltip" data-placement="top" title="Supprimer le participant"
                         @click="delete_participant(index)">
                        <i class="fas fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
        <div class="col-lg-3 order-lg-2 mb-7 mb-lg-0">
          <div class="pl-lg-4">
            <div class="card shadow-soft p-4 mb-4">
              <div class="border-bottom pb-4 mb-4"><h2 class="h3 mb-0 text-primary">Récapitulatif</h2>
              </div>
<!--              <div class="media align-items-center pb-4 mb-4">-->
<!--                <span class="d-block font-size-1 mr-3">Total</span>-->
<!--                <div class="media-body text-right">-->
<!--                  <span class="text-dark font-weight-bold">{{ get_total() }}  €</span>-->
<!--                </div>-->
<!--              </div>-->
<!--                            <div class="media align-items-center pb-4 mb-4">-->
<!--                              <span class="d-block font-size-1 mr-3">Total</span>-->
<!--                              <div class="media-body text-right">-->
<!--                                <span class="text-dark font-weight-bold">{{ get_total() }}  €</span>-->
<!--                              </div>-->
<!--                            </div>-->

              <div v-if="adult_present && phone_present" class="w-100">
                <div v-if="event.event_price > 0" class="w-100 text-center cart_navigation clearfix">
                  <button v-if="customer.id && 1==2" type="button" data-toggle="modal" data-target="#payment_card_modal"
                          title="Payer ma réservation par carte" class="btn btn-primary mb-1">
                    <i class="fas fa-credit-card"></i> &nbsp;Payer par carte
                  </button>
                  <button type="button" data-toggle="modal" data-target="#payment_cash_modal"
                      title="Payer ma réservation en espèce" class="btn btn-primary"><i
                      class="fas fa-coins"></i> &nbsp;Payer en espèce
                  </button>
                </div>

                <div v-else class="w-100 text-center cart_navigation clearfix">
                  <button type="button" @click="post_reservation()"
                          title="Payer ma réservation en espèce" class="btn btn-primary"><i
                      class="fas fa-coins"></i> &nbsp;Réserver
                  </button>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div v-else id="content" class="dlnkcalendar-multi-registration">
      <!--    <div id="event_rule" class="w-80 mx-lg-auto my-2 alert alert-info mb-4">-->
      <div class="w-80 mx-lg-auto my-2 alert alert-danger mb-4">
        Vous avez atteint votre quota de réservation. Veuillez contacter l'équipe CSAM pour reserver
      </div>
    </div>

  </div>

</template>

<script>

import '@fullcalendar/core/vdom' // solves problem with Vite https://fullcalendar.io/docs/vue
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list';
import frLocale from '@fullcalendar/core/locales/fr';
import interactionPlugin from '@fullcalendar/interaction'

export default {

  components: {
    FullCalendar // make the <FullCalendar> tag available
  },


  props: {
    event_id: '',
  },

  data: function () {
    return {
      adult_present: Boolean,
      phone_present: Boolean,
      notice: Boolean,
      customer: Object,
      message: '',
      message_type: '',
      waitings: Array(),
      participants: Array(),
      lastname: String,
      firstname: String,
      availability: Number,
      age: Number,
      phone: String,
      event: Object,
      waiting_list_open: Boolean,
      reservation_open: Boolean,
      calendar_key: 0,
      calendar_options: {
        locale: frLocale,
        plugins: [ dayGridPlugin, interactionPlugin, listPlugin, timeGridPlugin ],
        initialView: 'listMonth',
        weekends: false, // initial value
        slotMinTime: '09:30',
        slotMaxTime: '17:30',
        eventClick: this.post_reservation,
        // eventBackgroundColor: '#378006',
        events: [
        ]
      }
    }
  },

  mounted() {
    const _this = this
    _this.waiting_list_open = false
    _this.waiting_list_open = false
    _this.adult_present = false
    _this.phone_present = false
    _this.notice = true

    $('#payment_cash_modal').on('shown.bs.modal', function (e) {
      let calendarApi = _this.$refs.full_calendar.getApi()
      calendarApi.render()
    });

    this.clear_form()
    this.get_data()
  },

  watch: {

    waitings: function (newVal, oldVal) {
      const _this = this
      _this.adult_present = false
      _this.phone_present = false
      newVal.forEach(function (user) {
        if (parseInt(user.age) > 17) _this.adult_present = true
        if (parseInt(user.phone) > 0 && user.phone.length > 9) _this.phone_present = true
      });
    },

    participants: function (newVal, oldVal) {
      const _this = this
      _this.adult_present = false
      _this.phone_present = false
      newVal.forEach(function (user) {
        if (parseInt(user.age) > 17) _this.adult_present = true
        if (parseInt(user.phone) > 0 && user.phone.length > 9) _this.phone_present = true
      });
    },


  },

  methods: {

    book: function() {
      const _this = this

      let info = {}

      this.post_reservation(info)

    },

    post_reservation: function (info) {
      const _this = this

      let message = ""
      let appointement_id = -1

      if (_this.event.event_price > 0) {
        message = "En cliquant, sur 'OK', vous confirmez votre réservation et votre rendez vous pour le "
            + info.event.start.toLocaleDateString() + ' à ' + info.event.start.toLocaleTimeString()
        appointement_id = info.event.id
      } else {
        message = "En cliquant, sur 'OK', vous confirmez votre réservation."
      }

      if (window.confirm(message))
      {
        const url = '/modules/dlnkcalendar/actions/reservations.php'
        const participants = JSON.stringify(_this.participants);
        const form_data = new FormData()
        form_data.append('event_id', _this.event_id)
        form_data.append('appointement_id', appointement_id)
        form_data.append('participants', participants);

        axios({
          method: 'post',
          url: url,
          data: form_data,
          headers: {"cache-control": "no-cache"},
        })
            .then(function (response) {
              const status = response.data.status

              if (status) {
                window.location.href = '/module/dlnkcalendar/reservation_confirmation';
              } else {
                _this.message = response.data.error;
                _this.message_type = "alert-danger";

                const error_code = response.data.error_code

                if(error_code == 1) {
                  _this.get_data()
                  _this.open_waiting_list()
                  $('#payment_cash_modal').modal('hide')
                }

              }

            })
            .catch(function (response) {
              //handle error
            });
      }
    },

    post_user_info: function () {
      const _this = this
      const url = "/module/dlnkcalendar/payment"
      const form = document.getElementById('user_info_form')
      const participants = JSON.stringify(_this.participants);
      const form_data = new FormData(form)
      form_data.append('rand', new Date().getTime())
      form_data.append('vuejs', 1)
      form_data.append('participants', participants);
      form_data.append('country', 'FR');
      form_data.append('amount', _this.get_total());
      form_data.append('submitUserInfo', 1);
      form_data.append('id_event', _this.event_id);


        axios({
        method: 'post',
        url: url,
        data: form_data,
        headers: {"cache-control": "no-cache"},
      })
          .then(function (response) {
            //handle success
            const status = response.data.status

            if(status == '0') {
              _this.message = response.data.error
              _this.message_type = "alert-danger"
            } else {
              document.getElementById('dlnkcalendar-wrapper').innerHTML = response.data
            }
          })
          .catch(function (response) {
            //handle error
          });
    },

    check_input: function () {
      if (this.lastname.length < 2) {
        this.message = 'Nom incorrect'
        this.message_type = 'alert-danger'
        this.lastname = ""
        return false
      }

      if (this.firstname.length < 2) {
        this.message = 'Prénom incorrect'
        this.message_type = 'alert-danger'
        this.firstname = ""
        return false
      }

      if (isNaN(parseInt(this.age)) || this.age.length < 1) {
        this.message = 'Age incorrect'
        this.message_type = 'alert-danger'
        this.age = ""
        return false
      }

      return true
    },

    clear_form: function () {
      this.lastname = ""
      this.firstname = ""
      this.age = ""
      this.phone = ""
    },

    close_message: function () {
      this.message = "";
      this.message_type = "";
    },

    close_notice: function () {
      this.notice = false
    },

    delete_participant: function (index) {
      this.participants.splice(index, 1)
    },

    delete_waiting: function (index) {
      this.waitings.splice(index, 1)
    },

    add_participant: function () {
      let participant = new Object()

      if (this.check_input()) {
        participant.lastname = this.lastname
        participant.firstname = this.firstname
        participant.phone = this.phone
        participant.age = this.age

        this.availability--
        this.participants.push(participant)
        this.$refs.firstname_input.focus();
        this.clear_form()
      }
    },

    add_waiting: function () {

      let waiting = new Object()

      if (this.check_input()) {
        waiting.lastname = this.lastname
        waiting.firstname = this.firstname
        waiting.phone = this.phone
        waiting.age = this.age

        this.waitings.push(waiting)
        this.$refs.waiting_firstname_input.focus();
        this.clear_form()
      }
    },

    get_data: function () {
      const _this = this

      const url = '/modules/dlnkcalendar/actions/events.php?action=event&event_id=' + _this.event_id

      axios.get(url)
          .then(function (response) {
            _this.event = response.data.event
            _this.availability = parseInt(_this.event.availability)
            _this.customer = response.data.customer
            _this.calendar_options.events =  response.data.appointments

            if (_this.availability > 0) {
              _this.reservation_open = true
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_total: function () {
      const _this = this
      let price = 5
      let total = 0

      if(_this.event.event_price > 0) {
        if (_this.waiting_list_open) {

          _this.waitings.forEach(function(member){
            if (_this.event.category_id == 32) {
              if (member.age <= 12) {
                total += 4.5
              } else {
                total += 7.5
              }
            } else {
              total += 5
            }
          });

        } else {
          _this.participants.forEach(function(member){
            if (_this.event.category_id == 32) {
              if (member.age <= 12) {
                total += 4.5
              } else {
                total += 7.5
              }
            } else {
              total += 5
            }
          });
        }

      }

      return total
    },

    open_reservation: function () {
      // Clear waitings
      this.waitings = []

      // Hide waitings
      this.waiting_list_open = false

      // Open wating list
      this.reservation_open = true
    },

    open_waiting_list: function () {
      // Clear reservation
      this.reservations = []

      // Hide Reservation
      this.reservation_open = false

      // Open wating list
      this.waiting_list_open = true
    },

    post_waitings: function () {
      const _this = this;
      const url = '/modules/dlnkcalendar/actions/waitings.php';

      const form_data = new FormData();
      const waitings = JSON.stringify(_this.waitings);
      form_data.append('waitings', waitings);
      form_data.append('event_id', _this.event_id);

      axios({
        method: 'post',
        url: url,
        data: form_data,
        headers: {"cache-control": "no-cache"},
      })
          .then(function (response) {
            //handle success
            const status = response.data.status

            if (status) {
              window.location.href = '/module/dlnkcalendar/waiting_confirmation';
            } else {
              _this.message = response.data.error;
              _this.message_type = "alert-danger";
            }
          })
          .catch(function (response) {
            alert('Erreur inconnu');
          });
    },
  }
}

</script>

<style scoped>

#payment_cash_modal .fc-event {
   background-color:red !important;
}

</style>